(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ------------------------------------------------------------------------
     Cats Protection: compact hover dropdowns for the desktop navigation.
     Added 2026-08-11 (polish pass). The box itself is styled in
     assets/cp-custom.css, header region H5.

     Why this exists at all. The Dogs Trust pattern is pure CSS because DT
     builds its nav out of a plain <a> and a sibling <ul>, so :hover and
     :focus-within can show the panel. Refresh builds it out of <details>,
     which does not render its panel until the open attribute is set, and no
     amount of CSS can set an attribute. So the hover and focus behaviour is
     scripted, and it works by setting that same attribute, which means
     everything the theme already does keeps working untouched:
     DetailsDisclosure closes on focusout, global.js closes on Escape and puts
     focus back on the label, and StickyHeader closes the lot when the bar
     hides on scroll.

     If this script never runs, the nav still works: click opens the panel,
     click closes it, which is stock Refresh.

     Rules it holds to:
     - Hover only where hovering is real. Gated on (hover: hover) and
       (pointer: fine) and the 990px breakpoint where the inline menu appears.
       Below that the drawer runs, and the drawer is not touched.
     - Focus opens it, the way DT's :focus-within does, but only for
       :focus-visible. Without that gate a tap would open the panel on focus
       and the click that follows would close it again, so touch users would
       see nothing happen.
     - Escape closes it and it stays closed. global.js returns focus to the
       label, which would otherwise re-open the panel through the focus rule
       above.
     - Nothing here runs on the mobile drawer: every selector is scoped to
       header-menu inside .section-header.
     ------------------------------------------------------------------------ */
  (function cpNavDropdowns() {
    /* 160ms, the Dogs Trust nav figure. Held in step with --cp-nav-dur in
       assets/cp-custom.css: change one, change the other, or the panel is
       removed from the page before it has finished fading out. */
    const CLOSE_MS = 160;
    const HOVER_QUERY = '(hover: hover) and (pointer: fine) and (min-width: 990px)';

    const canHover = () => window.matchMedia(HOVER_QUERY).matches;
    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const menuOf = (node) => (node && node.closest ? node.closest('.section-header header-menu') : null);

    /* The menu Escape was pressed in. Held until focus moves somewhere else. */
    let escaped = null;

    /* global.js wires aria-expanded on every summary once, at load. It does not
       re-wire a section the theme editor has re-rendered, so the state is set
       here too rather than assumed. */
    function syncAria(details) {
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function open(menu) {
      const details = menu.querySelector('details');
      if (!details) return;

      clearTimeout(details.cpCloseTimer);
      details.classList.remove('cp-nav-closing');
      if (details.open) return;

      details.open = true;
      syncAria(details);
    }

    function close(menu, immediate) {
      const details = menu.querySelector('details');
      if (!details || !details.open) return;

      const finish = () => {
        clearTimeout(details.cpCloseTimer);
        details.classList.remove('cp-nav-closing');
        details.open = false;
        syncAria(details);
      };

      if (immediate || prefersReducedMotion()) {
        finish();
        return;
      }

      /* Kept open, and marked, for exactly as long as the close animation
         runs. Dropping the attribute now would remove the panel mid fade. */
      details.classList.add('cp-nav-closing');
      clearTimeout(details.cpCloseTimer);
      details.cpCloseTimer = setTimeout(finish, CLOSE_MS);
    }

    document.addEventListener('mouseover', (event) => {
      if (!canHover()) return;
      const menu = menuOf(event.target);
      if (!menu) return;

      /* A hold, from a click or from Escape, is only meant to last while the
         pointer stays where it is. Arriving from outside the item is a fresh
         approach and clears it, so the next hover always works. */
      if (!event.relatedTarget || !menu.contains(event.relatedTarget)) menu.cpHoverHeld = false;
      if (menu.cpHoverHeld) return;

      open(menu);
    });

    document.addEventListener('mouseout', (event) => {
      if (!canHover()) return;
      const menu = menuOf(event.target);
      if (!menu) return;
      /* Moving between the label, the bridge and the panel is all still inside
         the same header-menu, so only a genuine exit closes it. */
      if (event.relatedTarget && menu.contains(event.relatedTarget)) return;
      menu.cpHoverHeld = false;
      close(menu);
    });

    /* A click on the label means dismiss. <details> has already toggled itself
       by the time this fires, so hover is held off until the pointer leaves,
       or the panel would spring straight back open under a cursor that has not
       moved. */
    document.addEventListener('click', (event) => {
      const menu = menuOf(event.target);
      if (!menu || !event.target.closest('summary')) return;
      const details = menu.querySelector('details');
      if (!details) return;
      menu.cpHoverHeld = !details.open;
      syncAria(details);
    });

    document.addEventListener('focusin', (event) => {
      const menu = menuOf(event.target);
      if (menu !== escaped) escaped = null;
      if (!menu || menu === escaped) return;

      let keyboard = false;
      try {
        keyboard = event.target.matches(':focus-visible');
      } catch (error) {
        keyboard = false;
      }
      if (!keyboard) return;

      open(menu);
    });

    /* Escape closes it, at once, and it stays closed.

       global.js already does this for any <details> whose id starts with
       "Details-", but only for the elements that were on the page when it ran,
       so a section the theme editor has re-rendered loses the behaviour. It is
       repeated here so the panel is never a keyboard trap. Doing it twice is
       harmless: whichever runs second finds the panel already shut.

       Capture phase, so `escaped` is set before focus goes back to the label.
       Without that the focus rule above would re-open the panel and Escape
       would look broken. Hover is held off for the same reason: the pointer may
       still be sitting on the label. */
    document.addEventListener(
      'keyup',
      (event) => {
        if (event.key !== 'Escape' && event.code !== 'Escape') return;
        const menu = menuOf(event.target);
        if (!menu) return;

        escaped = menu;
        menu.cpHoverHeld = true;
        close(menu, true);

        const summary = menu.querySelector('summary');
        if (summary) summary.focus();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
